define('views/abstract-comments/list',[
  "globals",
  "backbone",
], function (globals, Backbone) {
  "use strict";

  return Backbone.View.extend({
    destroy: function () {
      this.undelegateEvents().remove();
      return this;
    }
  });
});

